"use client";
// css
import styles from "./index.module.scss";
//ts
import { generateUniqueId } from "@/app/utils/string";
import { useCallback, useEffect } from "react";
import { isApp } from "@/app/bridge";
import { useTranslations } from "@/app/lib/LocaleProvider";
// type
import { RobotAIKeywordItem } from "@/app/types/typeConfig/chatQuestion";
import {
  ReportBizTypeEnum,
  ReportEventEnum,
  ReportKeywordContentEnum,
  ReportSceneTypeEnum,
} from "@/app/types/typeConfig/report";
// view
import Image from "next/image";
import { message } from "antd";
//hooks
import useReportRequestQueue from "@/app/hooks/robot/useReportRequestQueue";
import { useSSESend } from "@/app/hooks/robot/useSSESend";
import { useMessageStore } from "@/app/store";
export interface mobileRobotAIKeywordItem extends RobotAIKeywordItem {
  printerModel?: string;
}
interface SelectQuestionProps {
  data: mobileRobotAIKeywordItem[];
  lng?: string;
  id: string;
  title?: string;
}

export default function SelectHotQuestion({
  data,
  title,
}: SelectQuestionProps) {
  const { batchToReportQueue, addToReportQueue } = useReportRequestQueue();
  const t = useTranslations();
  const { handleSSESend, isSending } = useSSESend();
  const { aiTypingEnd } = useMessageStore();

  const onClick = useCallback(
    (item: RobotAIKeywordItem) => {
      // 防抖：如果正在发送、打字机效果未结束、或 SSE 流未结束，禁止点击
      if (
        isSending ||
        !aiTypingEnd ||
        useMessageStore.getState().isAIStreaming
      ) {
        message.warning(t.selectHotAIQuestion.replying);
        return;
      }
      const uniqueKey = generateUniqueId();
      // sessionStorage.setItem("ai-chat-id", uniqueKey);
      addToReportQueue({
        bizType: ReportBizTypeEnum.AI_HOT_KEY,
        content: item.keyword,
        contentId: item.id,
        contentType: ReportKeywordContentEnum.AI_KEYWORD, // 热门推荐
        createTime: new Date().getTime(),
        eventType: ReportEventEnum.CLICK,
        scene: ReportSceneTypeEnum.AI_CONSULT,
      });
      const params = {
        content: item.keyword,
        contentId: item.id,
        bizType: ReportBizTypeEnum.AI_CHAT,
        contentType: ReportKeywordContentEnum.AI_KEYWORD,
      };
      handleSSESend(params);
    },
    [isSending, aiTypingEnd, addToReportQueue, handleSSESend],
  );
  const getTitle = (title: string) => {
    // 设备页浮球：promptType = 2；
    // 发起打印流程中：promptType = 3；
    // 帮助中心搜索：promptType = 4；
    // 绑定打印机, 识别到打印机：promptType = 5；
    // 绑定打印机, 未识别到打印机：promptType = 6；
    switch (title) {
      case "1":
      case "2":
      case "4":
        return t.selectHotAIQuestion.hotThinking;
      case "3":
        return t.selectHotAIQuestion.printerTips;
      case "5":
        return data[0]?.printerModel
          ? t.selectHotAIQuestion.bindingPrinterTips(data[0]?.printerModel)
          : t.selectHotAIQuestion.bindingPrinterTipsNoPrinter;
      case "6":
        return t.selectHotAIQuestion.bindingPrinterTipsNoPrinter;
      default:
        return t.selectHotAIQuestion.hotThinking;
        break;
    }
  };

  useEffect(() => {
    batchToReportQueue(
      data.map((item) => ({
        bizType: ReportBizTypeEnum.AI_HOT_KEY,
        content: item.keyword,
        contentId: item.id || undefined,
        contentType: ReportKeywordContentEnum.AI_KEYWORD,
        createTime: new Date().getTime(),
        eventType: ReportEventEnum.SHOW,
        scene: ReportSceneTypeEnum.AI_CONSULT,
        cacheKey: `mobile_${item.id}_${ReportKeywordContentEnum.AI_KEYWORD}${
          isApp() ? "_handy_app" : ""
        }`,
      })),
    );
  }, [data, batchToReportQueue]);

  return (
    <div className={styles.hotQuestionListMobileWrapper}>
      <div className={styles.hotQuestionTitle}>
        {title ? getTitle(title) : t.selectHotAIQuestion.hotTopics}
      </div>
      <div className={styles.hotQuestionList}>
        {data.map((item) => {
          return (
            <div
              key={item.id}
              className={styles.questionItemWrapper}
              onClick={() => onClick(item)}
            >
              <div className={styles.questionItem}>
                <span className={styles.mark}></span>
                <span className={styles.questionName}>{item.keyword}</span>
              </div>
              <Image
                src="/images/arrow-right-fill.svg"
                height={20}
                width={20}
                alt=""
              />
            </div>
          );
        })}
      </div>
    </div>
  );
}
